export default __webpack_public_path__ + "static/media/1058.a8c197d6.svg";